// Header.tsx
import React, {useEffect, useRef, useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircle, faKey, faQuestionCircle, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import {useAuth} from './AuthContext';
import {useNavigate} from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const {setIsLoggedIn, username} = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setDropdownVisible(v => !v);
  const handleLogout = () => { setIsLoggedIn(false); localStorage.removeItem('token'); navigate('/login'); };
  const handleChangePassword = () => navigate('/user/change-password');

  useEffect(() => {
    const h = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) setDropdownVisible(false);
    };
    if (isDropdownVisible) document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [isDropdownVisible]);

  return (
    <div className="header-container">
      {/* 左：Logo */}
      <div className="header-left">
        <div className="logo">
          <img src="/images/logo.png" alt="Business Logo" className="logo-image" />
        </div>
      </div>

      {/* 右：用户区 */}
      <div className="user-actions">
        <button aria-label="Help">
          <FontAwesomeIcon icon={faQuestionCircle}/>
        </button>
        <button onClick={toggleDropdown} aria-label="User Menu">
          <FontAwesomeIcon icon={faCircle}/>
        </button>

        {isDropdownVisible && (
          <div ref={dropdownRef} className="user-dropdown-menu">
            <span>{username || 'Guest'}</span>
            <button onClick={handleChangePassword}>
              <FontAwesomeIcon icon={faKey} className="icon"/> Change Password
            </button>
            <button onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} className="icon"/> Sign Out
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
